import { ActionCreator, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { ApplicationState } from '../rootReducer';
import { BlazeMeterApiResponse } from '../../types/rest/blazeMeterApiResponse';
import acApi from '../../axios/ac/acApi';
import { showToastNotification } from '../ui/toasts/toastsActions';
import { ToastType } from '../ui/toasts/toastsTypes';
import { updateSecretsVaultList } from './secretsVaultReducer';
import { isFeatureEnabled } from '../../utils/bzmUserConfigUtil';

/**
 * Gets List of Secrets
 */
export const getSecretsListAction: ActionCreator<any> = (): ThunkAction<any, ApplicationState, null, any> => {
  return async (dispatch: ThunkDispatch<any, any, any>) => {
    if (!isFeatureEnabled('secretsPrivateVault') || !isFeatureEnabled('enableSecrets')) {
      return;
    }
    try {
      const response: BlazeMeterApiResponse = (await acApi.secrets.getVaultIntegrationList()).data;
      dispatch(updateSecretsVaultList(response.result));
    } catch (error) {
      dispatch(showToastNotification(ToastType.Danger, error.response.data.error));
    }
  };
};
